<script>
export default {
  name: "CheckoutWrapper"
}
</script>

<template>
<div>
  <router-view/>
</div>
</template>

<style scoped>

</style>